import { Link, useForm } from '@inertiajs/inertia-react';
import Form from 'app/fragments/Forms/Form';
import Search from 'app/fragments/Forms/Search';
import { EditMenuContext } from 'app/fragments/TaskCard';
import { UserAvatar } from 'app/fragments/UserAvatar';
import { roundTo } from 'app/utils/utils';
import React, { useContext } from 'react'
import route from 'ziggy-js';
import usePageProps from '../hooks/usePageProps';
import Icon from '../Icon';
import Img from '../Image';
import { ProjectType } from '../Types/ProjectType';
import { TaskType } from '../Types/TaskType';
import { UserType } from '../Types/UserType';

interface Props {
    heading?: string
}

function Header(props: Props) {
    const { heading } = props

    const { user } = usePageProps<{ user: UserType }>();

    // let key = route().current()?.startsWith('tasks.') ? 'search_tasks' : 'search_projects';
    let key = route().current()?.startsWith('tasks.') ? 'task' : 'project';
    const form = useForm({});
    const { data } = form;

    let notifications = [];

    const { opened, setOpened } = useContext(EditMenuContext);

    return (
        <header className='w-full flex justify-between pt-40px pb-20px sticky top-0 pl-200px pr-130px bg-black/25 backdrop-blur-2xl z-99999 mob:px-20px mob:flex-wrap'>
            <h1 className='text-h32 font-semibold'>{heading}</h1>
            {/* <div className='w-325px bg-gray-1C1C1C rounded'></div> */}
            <Form form={form} className="w-325px mob:basis-full mob:order-3 mob:mt-16px">
                <Search<TaskType | ProjectType>
                    name='search'
                    keyName={`search_${key}s`}
                    optionsCallback={(r) => ({
                        text: r.name,
                        element: (
                            // <SearchCard name={`${r.name} | ${r.project.name} `} image={null} href={"#"} />
                            <Link href={route(`${key}s.show`, {[key]: r.id})} className='flex justify-between items-center gap-12px text-white p-16px border-t border-black'>
                                <div className='text-16'>{r.name}</div>
                                {('project' in r) && <div className='bg-gray-343434 rounded-full px-6px py-4px text-14 font-medium'>{r.project.name}</div>}
                            </Link>
                        ),
                        value: r.id,
                    })}
                />
            </Form>
            <div className='flex gap-12px items-center mob:order-2'>
                <div className={`${ (notifications?.length ?? 0) > 0 ? 'bg-red-D8252B' : 'bg-gray-1C1C1C'} text-white p-8px px-12px rounded-full flex items-center`}>
                    <Icon name="bell" />
                    <div className='text-12 font-semibold'>{(notifications?.length ?? 0)}</div>
                </div>
                <Link href={route('user.show', { user: user?.UUID })}>
                    <UserAvatar user={user} />
                </Link>
                <button onClick={(e) => {e.preventDefault(); e.stopPropagation(); setOpened(o => o?.type == 'sidemenu' ? null : {id: 1, type: 'sidemenu'})}}
                    className="flex flex-col gap-6px nMob:hidden"
                >
                    <div className={`h-4px w-26px bg-white rounded-full transition-all ${opened?.type == 'sidemenu' && 'rotate-45 translate-y-5px '}`}/>
                    <div className={`h-4px w-26px bg-white rounded-full transition-all ${opened?.type == 'sidemenu' && 'hidden'}`}/>
                    <div className={`h-4px w-26px bg-white rounded-full transition-all ${opened?.type == 'sidemenu' && '-rotate-45 -translate-y-5px '}`}/>
                </button>
            </div>
        </header>
    )
}

export default Header
